import { EXTERNAL_CHANNEL, MARKET_SDK_CHANNEL, APPLY_SOURCE } from "@/constants/common";
import { isMgm, isOfficalWeb, isMarket } from "./scene";

// 判断当前是移动端、pc端
export const deviceDetector = () => {
  const userAgent = navigator.userAgent.toLowerCase();
  const isMobile = /iphone|ipod|android|windows phone|blackberry|opera mini|mobile/i.test(userAgent);
  return isMobile
}

// 文案高亮
export const addHighlightStyle = (transResult: string, className: string) => {
  const regexp = /{([^}]+)}/g;
  return transResult.replace(regexp, `<span class="${className}">$1</span>`);
};

// 是否超过24小时
export const isOver24Hours = (timestamp: number) => {
  const currentTimestamp = Date.now();  // 当前时间戳（毫秒级）
  const difference = currentTimestamp - timestamp;  // 时间差，单位：毫秒

  // 判断时间差是否大于等于 24 小时（24 小时 * 60 分钟 * 60 秒 * 1000 毫秒）
  return difference >= 24 * 60 * 60 * 1000;
}

// localStorage方法
export const Storage = {
  // 设置数据
  setItem(key: string, value: any) {
    // 如果 value 是对象或数组，需要将其转换为 JSON 字符串
    if (typeof value === 'object') {
      value = JSON.stringify(value);
    }
    localStorage.setItem(key, value);
  },

  // 获取数据
  getItem(key: string) {
    const value = localStorage.getItem(key);
    // 如果获取到的是 JSON 格式的数据，自动解析
    if (value) {
      try {
        return JSON.parse(value);
      } catch (e) {
        return value;  // 如果不是 JSON 格式，直接返回原值
      }
    }
    return null;  // 如果没有数据，返回 null
  },
}

export const getExternalChannel = () => {
  const isMarket = window?.adv?.isAdvChannel()
  if (isMarket) {
    const channel = window?.adv?.getChannelEnv()
    switch (channel) {
        case MARKET_SDK_CHANNEL.ec: {
            return EXTERNAL_CHANNEL.ec
        }
      case MARKET_SDK_CHANNEL.meta: {
        return EXTERNAL_CHANNEL.meta
      }
      case MARKET_SDK_CHANNEL.google: {
        return EXTERNAL_CHANNEL.google
      }
      case MARKET_SDK_CHANNEL.tiktok: {
        return EXTERNAL_CHANNEL.tiktok
      }
      default: {
        return EXTERNAL_CHANNEL.other
      }
    }
  } else if (isMgm()) {
    return EXTERNAL_CHANNEL.mgm
  } else if (isOfficalWeb()) {
    return EXTERNAL_CHANNEL.web
  } else {
    return EXTERNAL_CHANNEL.other
  }
}

// 获取埋点申请渠道参数
export const getOmegaApplySource = () => {
  if (isMgm()) {
    return APPLY_SOURCE['MGM']
  }
  if (isOfficalWeb()) {
    return APPLY_SOURCE['WEB']
  }
  if (isMarket()) {
    return APPLY_SOURCE['OUT']
  }
  return APPLY_SOURCE.DEFAULT
}


/**
 * 有意义时间打点
 */
export function markPerformanceFMP() {
  try {
    performance?.mark('fmp')
  } catch (err) {
    console.error('performance mark not find')
  }
}